// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-search-by-writer-tab .table-head {
  padding: 2.4rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.public-search-by-writer-tab .items-container {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #333;
  margin-bottom: 3.2rem;
}
.public-search-by-writer-tab .items-container .no-items-text {
  text-align: center;
  padding-top: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/PublicSearchScene/PublicSearchByWriterTab/index.scss"],"names":[],"mappings":"AAGE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,mBAAA;AAHN","sourcesContent":["@use '@Styles/variables';\n\n.public-search-by-writer-tab {\n  .table-head {\n    padding: 2.4rem 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .items-container {\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid variables.$grayColor1;\n    margin-bottom: 3.2rem;\n\n    .no-items-text {\n      text-align: center;\n      padding-top: 1.2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
